import commonPostTypeConfig from '../../common/postTypes/profile'

export default function initPostType({ wapp }) {
    return wapp.client.postTypes.getPostType({
        name: 'profile',
        addIfThereIsNot: true,
        statusManager: commonPostTypeConfig.getStatusManager()
    })
}
